import { useRef, useEffect } from "react";
import JsBarcode from "jsbarcode";
import { toPng } from "html-to-image";
import { Download, Printer } from "lucide-react";

const BarcodeLabel = ({ barcodeValue, name, price }) => {
  const { outlet_name } = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const svgRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    if (svgRef.current) {
      JsBarcode(svgRef.current, barcodeValue, {
        format: "CODE128",
        lineColor: "#000",
        width: 3,
        height: 60,
        displayValue: false,
        margin: 0,
      });
    }
  }, [barcodeValue]);

  const handleDownload = () => {
    if (labelRef.current) {
      toPng(labelRef.current, {
        quality: 1.0,
        pixelRatio: 2,
      })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = `${name}_label.png`;
          link.href = dataUrl;
          link.click();
        })
        .catch((err) => {
          console.error("Error generating PNG:", err);
        });
    }
  };

  const handlePrint = () => {
    if (labelRef.current) {
      const printContent = labelRef.current.innerHTML;

      const html = `
      <html>
        <head>
          <title>Print Label</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
            }
            .label-container {
              width: 240px;
              min-height: 115px;
              font-family: Arial, sans-serif;
              border: 1px solid #ccc;
              padding: 8px;
              border-radius: 8px;
              text-align: center;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .barcode-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 200px;
              margin-bottom: 4px;
            }
            svg {
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
          <div class="label-container">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `;

      // ✅ Instead of document.write, make a blob
      const blob = new Blob([html], { type: "text/html" });
      const url = URL.createObjectURL(blob);

      // ✅ Open blob in new window
      const printWindow = window.open(url, "_blank", "width=800,height=600");

      // optional: free memory after window is created
      printWindow.onload = () => {
        URL.revokeObjectURL(url);
      };
    }
  };

  return (
    <div className="flex flex-col items-center gap-2 mt-2">
      <div
        ref={labelRef}
        className="bg-white border border-gray-400 rounded-lg p-1 flex flex-col items-center justify-center shadow-sm"
        style={{
          width: "240px",
          minHeight: "115px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Shop Name */}
        <div className="text-[10px] font-semibold text-gray-600 mb-0.5 text-center uppercase tracking-wide">
          {outlet_name}
        </div>
        {/* Product Name */}
        <div className="text-xs font-medium text-gray-900 mb-1 text-center leading-snug">
          {name}
        </div>

        {/* Barcode */}
        <div
          className="flex justify-center mb-1"
          style={{
            width: "200px",
          }}
        >
          <svg ref={svgRef}></svg>
        </div>

        {/* ID & Price */}
        <div className="text-[9px] font-normal text-gray-700 text-center">
          <div className="flex items-center justify-center gap-2">
            <span className="font-semibold">ID: {barcodeValue}</span>
            <span className="font-semibold">|</span>
            <span className="font-semibold">Price: {price}</span>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-2">
        <button
          onClick={handleDownload}
          className="flex justify-center items-center gap-2 px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium text-xs"
        >
          <Download className="h-4 w-4" /> Download
        </button>
        <button
          onClick={handlePrint}
          className="flex justify-center items-center gap-2 px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors font-medium text-xs"
        >
          <Printer className="h-4 w-4" /> Print
        </button>
      </div>
    </div>
  );
};

export default BarcodeLabel;
